import { diffText } from '~/utils/diff';
const getClassificationDiff = (cellValue, anchorText, comparatorText) => {
    const diffs = diffText(anchorText, comparatorText, { textOnly: true });
    diffs.forEach(diff => {
        if (typeof diff.text === 'string' && diff.text.length) {
            cellValue.richText.push({
                font: {
                    strike: diff.type === 'red',
                    color: {
                        argb: diff.type === 'green'
                            ? 'FF008000'
                            : diff.type === 'red' ? 'FFFF0000' : 'FF000000',
                    },
                },
                text: diff.text,
            });
        }
    });
    return cellValue;
};
const getClassificationComments = (classification, isExportingPrivilegedComments, selectedPrivilegeGroupIds) => {
    const classificationComments = [];
    classification.comments.forEach(comment => {
        var _a, _b;
        if (!isExportingPrivilegedComments &&
            comment.privilegeGroups &&
            ((_a = comment.privilegeGroups) === null || _a === void 0 ? void 0 : _a.length) > 0)
            return;
        const commentPrivilegeGroupIds = (_b = comment.privilegeGroups) === null || _b === void 0 ? void 0 : _b.map(pg => pg.id);
        if (commentPrivilegeGroupIds &&
            commentPrivilegeGroupIds.length &&
            !commentPrivilegeGroupIds.some(x => selectedPrivilegeGroupIds.includes(x))) {
            return;
        }
        classificationComments.push(comment);
    });
    return classificationComments;
};
export { getClassificationDiff, getClassificationComments, };
